import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.BOOK_CLUB;

export const NUM_K2_LEVELS = 12;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
  CHARACTER_INTRO: 'CHARACTER_INTRO',
};

// The id for bonus animation when clicking help
export const BONUS_BOOK_ANIMATION = 'DANCING-BOOKS';

// The string identifier for when both books can answer the question
export const BOTH_CORRECT = 'BOTH';

export const QUESTIONS_COUNT_TO_BEAT_LEVEL = 3;
export const QUESTIONS_PER_CHARACTER = 4;

export const FEEDBACK_STATES = {
  NONE: 'NONE',
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
};

export const ROUND_STATES = {
  INSTRUCTION: 'INSTRUCTION', // App is teaching a reading concept or skill to student
  FEEDBACK: 'FEEDBACK', // App is providing feedback on a student's response
  QUESTION_ITEM: 'QUESTION_ITEM', // Student is in "standard" mode of answering a question in game
  NO_ACTIVE_ROUND: 'NO_ACTIVE_ROUND', // No Book Club round is in progress
};

// number of onboarding overlay screens to scroll through when running onboarding
export const NUM_ONBOARDING_SCREENS = 2;

export const REDUX_ACTIONS = {
  DISPLAY_BOOK_PASSAGE: 'DISPLAY_BOOK_PASSAGE',
  END_FEEDBACK_PHASE: 'END_FEEDBACK_PHASE',
  END_ROUND: 'END_ROUND',
  MASTER_LEVEL: 'MASTER_LEVEL',
  SELECT_RESPONSE_BOOK: 'SELECT_RESPONSE_BOOK',
  START_ROUND: 'START_ROUND',
  RETURN_TO_PROGRESS_SCREEN: 'RETURN_TO_PROGRESS_SCREEN',
  CONTINUE_TO_STANDARD: 'CONTINUE_TO_STANDARD',
  NEXT_CHARACTER_INTRO_TEXT: 'NEXT_CHARACTER_INTRO_TEXT',
  ADVANCE_ONBOARDING_SCREEN: 'ADVANCE_ONBOARDING_SCREEN',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  SET_ALYX_STATE: 'SET_ALYX_STATE',
  COMPLETE_ITEMS: 'COMPLETE_ITEMS',
  SHOW_STAMP: 'SHOW_STAMP',
  SET_LEVEL_COUNT: 'SET_LEVEL_COUNT',
  QUICK_ROUND: 'QUICK_ROUND',
};
